export default { sha: '54ae215840623eef4955b7d36cf0f1bde0fd2ea4', buildNumber: 'undefined' }
